export default __webpack_public_path__ + "static/media/tourismInMexico.8c09e9ad.jpg";